import React from "react"
import PropTypes from "prop-types"
// import { ComponentError } from 'components'
import { getComponentDisplayName, constructOutputProps, jsonToComponents } from "../utils"

const whiteListToObject = list =>
  list
    .filter(Boolean)
    .reduce((all, entry) => ({
      ...all,
      [entry.displayName || entry.name]: entry
    }), {})

/**
 * Higher order component for parsing (json) CMS components from to react children
 * @param {Object} options - Initial config options.
 * @param {Array} options.componentWhiteList -
 * Array of components that can be used as children.
 * @param {Array} options.mapInputToOutput -
 * Array of input key output key mappings for multiple dynamic component areas.
 * @returns {Function} The configured higher order component,
 * which in turn will return a component class.
 */
export default ({
  componentWhitelist = [],
  mapInputToOutput = [["components", "children"]],
  mapInput = comp => comp // Escape hatch for pending CMS name / props changes
} = {}) => (Wrapped) => {
  class withDynamicComponents extends React.Component {
    getChildContext() {
      const { componentWhitelist: parentComponentWhitelist = {} } = this.context
      return {
        componentWhitelist: {
          ...parentComponentWhitelist,
          ...whiteListToObject(componentWhitelist)
        }
      }
    }

    render() {
      const { children, ...props } = this.props
      const { componentWhitelist: parentComponentWhitelist = {} } = this.context
      return (
        <Wrapped
          {...constructOutputProps(
            props,
            mapInputToOutput,
            jsonToComponents(
              {
                ...parentComponentWhitelist,
                ...whiteListToObject(componentWhitelist)
              },
              mapInput,
              getComponentDisplayName(Wrapped), {
                children
              })
          )} />
      )
    }
  }

  withDynamicComponents.contextTypes = {
    componentWhitelist: PropTypes.object
  }

  withDynamicComponents.childContextTypes = {
    componentWhitelist: PropTypes.object
  }

  withDynamicComponents.displayName = `withDynamicComponents(${getComponentDisplayName(Wrapped)})`

  withDynamicComponents.propTypes = {
    components: PropTypes.array,
    children: PropTypes.array
  }

  return withDynamicComponents
}



// WEBPACK FOOTER //
// ./src/higher-order-components/with-dynamic-components.jsx